import { ParsedUrlQuery } from 'querystring';

import { useMemo } from 'react';

import { useParams, useSearchParams } from 'next/navigation';

import { useSkipEffectOnMount } from '@hooks/lifecycle';
import clean from '@utils/cleanObject';
import useRouterNext from '@hooks/useRouterNext';

import { paramsToObject } from '../utils';

const usePaginationHook = (selectedPage: number) => {
  const { push } = useRouterNext();
  const searchParams = useSearchParams();
  const params = useParams();
  const query: ParsedUrlQuery = useMemo(() => {
    return paramsToObject(searchParams?.entries());
  }, [searchParams]);

  useSkipEffectOnMount(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { ...nextQuery } = query;

    if (
      (selectedPage === 1 && nextQuery.page === undefined) ||
      (query.page !== undefined && +query.page === 1) ||
      (selectedPage === 1 && nextQuery.page && +nextQuery.page === 2)
    ) {
      delete nextQuery.page;
    }

    const queryUrl =
      selectedPage === 1
        ? clean({ ...nextQuery, page: null })
        : { ...nextQuery, page: selectedPage };

    push({
      pathname: `/${params.slug}`,
      query: queryUrl,
    });
  }, [selectedPage]);
};

export default usePaginationHook;
